import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ServiceUsersReportResolverErrorStatesEnum {
    GetReportFailed = ErrorStateScheduleEnum.ServiceUserReportResolverStatesStartIndex,
    GetServiceUserSettingsFailed,
}
